// Wave 3 — Public individual service detail.
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicShell, { CapabilityTile } from "../../components/public/PublicShell";
import { api } from "../../lib/api";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    api.get(`/public/website/services/${slug}`)
      .then((r) => setService(r.data))
      .catch(() => setNotFound(true));
    api.get("/public/website/services").then((r) => {
      setRelated(r.data.filter((s) => s.slug !== slug).slice(0, 3));
    }).catch(() => {});
  }, [slug]);

  if (notFound) {
    return (
      <PublicShell>
        <section className="erf-public-section">
          <div className="erf-public-container">
            <h1>Service not found.</h1>
            <p style={{ color: "var(--exec-body)" }}>The service you're looking for doesn't exist.</p>
            <Link to="/services" className="erf-public-cta" style={{ marginTop: 20, display: "inline-block" }}>Back to services</Link>
          </div>
        </section>
      </PublicShell>
    );
  }
  if (!service) return <PublicShell><section className="erf-public-section"><div className="erf-public-container">Loading…</div></section></PublicShell>;

  const hero = (
    <section className="erf-public-hero" data-testid={`service-detail-hero-${service.slug}`} style={{ padding: "72px 0 56px" }}>
      <div className="erf-public-container">
        <div className="erf-public-hero-eyebrow">Service</div>
        <h1 style={{ maxWidth: 800 }}>{service.name}</h1>
        <p className="lead">{service.short_description}</p>
        <div className="erf-public-hero-actions">
          <Link to={`/quote?service=${service.slug}`} className="erf-public-cta" data-testid="service-detail-cta">Request a quote for this service</Link>
        </div>
      </div>
    </section>
  );

  return (
    <PublicShell hero={hero}>
      <section className="erf-public-section" data-testid="service-detail-body">
        <div className="erf-public-container" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "start" }}>
          <div>
            <CapabilityTile service={service} height={360} alt={`${service.name} — ERF ENTERPRISES LLC`} />
            <p style={{ fontSize: 12, color: "var(--exec-body)", marginTop: 12 }}>
              {service.short_description}
            </p>
          </div>
          <div>
            <div className="erf-public-eyebrow">What we deliver</div>
            <p style={{ fontSize: 16, lineHeight: 1.75, color: "var(--exec-body)", margin: "12px 0 24px" }}>
              {service.long_description || service.short_description}
            </p>
            {service.faqs && service.faqs.length > 0 && (
              <>
                <div className="erf-public-eyebrow" style={{ marginTop: 32 }}>FAQs</div>
                <div style={{ display: "grid", gap: 16, marginTop: 12 }}>
                  {service.faqs.map((f, i) => (
                    <div key={i}>
                      <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{f.q}</div>
                      <div style={{ color: "var(--exec-body)", fontSize: 14, lineHeight: 1.6 }}>{f.a}</div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {related.length > 0 && (
        <section className="erf-public-section-alt">
          <div className="erf-public-container">
            <h2 style={{ marginBottom: 32 }}>Related services</h2>
            <div className="erf-public-services-grid">
              {related.map((s) => (
                <Link key={s.slug} to={`/services/${s.slug}`} className="erf-public-service-card">
                  <CapabilityTile service={s} />
                  <div className="erf-public-service-card-body">
                    <h3>{s.name}</h3>
                    <p>{s.short_description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </PublicShell>
  );
}
